import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Flame = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M9.635 6.293S10.343 1.905 7.454 0c-.087 1.525-.787 2.938-1.923 3.887C4.296 5.03 1.976 7.6 2 10.34c-.019 2.39 1.25 4.583 3.275 5.66.072-1.068.549-2.061 1.323-2.755.657-.532 1.083-1.32 1.183-2.185 1.728.968 2.846 2.822 2.943 4.881v.013c1.91-.922 3.167-2.895 3.254-5.106.205-2.574-1.133-6.074-2.32-7.218-.45 1.054-1.146 1.971-2.024 2.663z"
        transform="translate(-1196 -1035) translate(1196 1035)"
      />
    </svg>
  );
};

Flame.displayName = 'Flame';
